'use strict';

angular.module('amexReconciliationApp')
  .component('summaryApprovals', {
    templateUrl: 'scripts/views/components/summary-approvals.html',
    bindings: {
      billingCycle: '<'
    },
    controller: function () {

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/summaryApprovals.js
// module id = 480
// module chunks = 0